import { render } from "./VideoUploader.vue?vue&type=template&id=db404534&scoped=true"
import script from "./VideoUploader.vue?vue&type=script&lang=js"
export * from "./VideoUploader.vue?vue&type=script&lang=js"

import "./VideoUploader.vue?vue&type=style&index=0&id=db404534&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db404534"]])

export default __exports__